import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWToggleButton = function TWToggleButton(_ref) {
  var checked = _ref.checked,
      name = _ref.name,
      onChange = _ref.onChange;

  var onChangeHandler = function onChangeHandler(event) {
    if (onChange) {
      onChange(event.target.name, event.target.checked);
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: "flex items-center justify-end w-full",
    children: /*#__PURE__*/_jsx("label", {
      className: "flex items-center cursor-pointer",
      "data-cy": "label_".concat(name),
      htmlFor: name,
      children: /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsx("input", {
          type: "checkbox",
          id: name,
          className: "sr-only",
          name: name,
          checked: checked,
          onChange: onChangeHandler
        }), /*#__PURE__*/_jsx("div", {
          className: classNames('block w-14 h-8 rounded-full checked', {
            'bg-gray-400': !checked,
            'bg-emerald-500': checked
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classNames('absolute left-1 top-1 bg-white w-6 h-6 rounded-full', {
            'transform translate-x-full': checked
          })
        })]
      })
    })
  });
};